import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';
import classNames from 'classnames';

import isEmpty from 'lodash/isEmpty';

import SectionVideoBackground from './section_video_background.jsx';

import { SECTION_WIDTH_CHANGE_EVENT } from 'zoomforth_codesbane_viewer/viewer/managers/subpage_resize_event_manager.jsx';

import { SECTION_TYPE_TILES } from 'zoomforth_codesbane_viewer/const/sections.js';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

import SectionManagerForViewerWrapper from './section_manager_for_viewer_wrapper.jsx';

class SectionManagerForViewerFullWidth extends Component {

  constructor() {
    super();

    this.state = {
      isInitialRender: true,
      sectionWidth: undefined
    };

    this.sectionRef = null;
    this.resizeKey = 'section' + Math.floor(Math.random()*1000000);

    autobind(this);
  }

  componentDidMount() {
    this.setState({
      isInitialRender: false,
      sectionWidth: $(APP_CONTAINER_SELECTOR).innerWidth()
    });

    $(window).on(`${SECTION_WIDTH_CHANGE_EVENT}.${this.resizeKey}`, () => {
      if (this.sectionRef) {
        this.setState({
          sectionWidth: $(this.sectionRef).innerWidth()
        });
      }
    });
  }

  componentWillUnmount() {
    $(window).off(`${SECTION_WIDTH_CHANGE_EVENT}.${this.resizeKey}`);
  }

  handleFullWidthSectionRefReceived(sectionRef) {
    this.sectionRef = sectionRef;

    if (this.props.onSectionRefReceive) {
      this.props.onSectionRefReceive(sectionRef);
    }

    this.setState({
      isInitialRender: false,
      sectionWidth: $(sectionRef).innerWidth()
    });
  }

  render() {
    const {
      backgroundStyle,
      backgroundClasses,
      backgroundVideoParams,
      cssClassesList,
      section,
      sectionProps,
      SectionRenderer,
      sectionWrapperClassname,
      sectionMarginStyle,
      sectionPaddingStyle,
      isChoosingTarget,
      children,
      isGlassOverlayEnabled,
      isCustomOverlayEnabled,
      overlayOpacity,
      overlayColor,
    } = this.props;

    if (this.state.isInitialRender) {
      return (
        <div
          id={section ? `section-id-${section.id}` : null}
          className={classNames('section-wrapper', sectionWrapperClassname, {
            'editing-target-for-internal-link': isChoosingTarget
          })}
        />
      );
    }

    // theoretically this will never happen but it's a nice safety measure
    if (this.state.sectionWidth === undefined) {
      throw new Error('sectionWidth must not be undefined -- it should have been set in the preload measurement phase');
    }

    const { sectionFontSize, ...restSectionProps } = sectionProps || {};

    // Grid sections are the only section which differs for where the padding
    // is applied. In that case we apply it to the `.tiles` inner div due to
    // backwards compatibility concerns. This is lame but handled.
    var sectionWrapperStyle = { ...backgroundStyle, ...sectionMarginStyle };
    if (section && section.type !== SECTION_TYPE_TILES) {
      sectionWrapperStyle = { ...sectionWrapperStyle, ...sectionPaddingStyle };
    }

    return (
      <SectionManagerForViewerWrapper
        tellRef={this.handleFullWidthSectionRefReceived}
        id={section ? `section-id-${section.id}` : null}
        className={classNames(`section-wrapper ${sectionWrapperClassname}`, sectionWrapperClassname, cssClassesList, backgroundClasses, {
          'editing-target-for-internal-link': isChoosingTarget
        })}
        style={{
          fontSize: sectionFontSize,
          ...sectionWrapperStyle
        }}
      >

        { !isEmpty(backgroundVideoParams) && <SectionVideoBackground {...backgroundVideoParams} /> }


        {
          (isGlassOverlayEnabled || isCustomOverlayEnabled) &&
            <div
              className="section-custom-overlay"
              style={{
                opacity: overlayOpacity || 1,
                backgroundColor: isCustomOverlayEnabled ? overlayColor || '#000000' : 'inherit'
              }}
            />
        }     

        <div style={{ position: 'relative', height: '100%' }}>
          <SectionRenderer
            section={section}
            sectionWidth={this.state.sectionWidth}
            sectionPaddingStyle={sectionPaddingStyle}
            isSectionFullWidth={true}
            {...restSectionProps}
          />

          {children}
        </div>
      </SectionManagerForViewerWrapper>
    );

  }

}

SectionManagerForViewerFullWidth.propTypes = {
  section: PropTypes.object,
  sectionWrapperClassname: PropTypes.string.isRequired,
  SectionRenderer: PropTypes.func.isRequired,
  onSectionRefReceive: PropTypes.func,
  isChoosingTarget: PropTypes.bool
};

export default SectionManagerForViewerFullWidth;
